export default __webpack_public_path__ + "static/media/DashboardProjects.0d01bb47.svg";